export interface Account {
  id: string;
  name: string;
}

export interface InterpolationValues {
  company?: string;
  chargeName?: string;
}

export enum PromptGroupKind {
  GENERAL = 'general',
  CRIMINAL = 'criminal',
}

export enum PromptItemKind {
  FILE = 'file',
  TEXT = 'text',
}

export interface PromptGroup {
  id: string;
  account: Account;
  enabled: boolean;
  kind: PromptGroupKind;
  items: PromptItem[];
}

export interface PromptItem {
  id: string;
  kind: PromptItemKind;
  required: boolean;
  translations: Translation[];
}

export interface Translation {
  language: string;
  title: string;
  description: string;
}

export interface CandidateStoryDocument {
  filename: string;
  handle: string;
  mimetype: string;
  originalPath: string;
  size: number;
  source: string;
  url: string;
  uploadId: string;
  originalFile: {
    name: string;
    type: string;
    size: number;
  };
  status: string;
  key: string;
  container: string;
}

export type PromptDocuments = Record<
  string,
  { documents: CandidateStoryDocument[] }
>;

export type RecordDocuments = Record<string, PromptDocuments>;

export interface CandidateStories {
  general?: { documents: CandidateStoryDocument[] };
  promptGroup?: any;
  [key: string]: any;
}

export type CandidateStoryRequestItem = {
  source_id: string;
  source_type: string;
};

export type CandidateStoryRequest = {
  created_at: string;
  updated_at: string;
  id: string;
  account: { id: string; name: string };
  report: {
    id: string;
    assessment: string;
    completed_at: string;
    location: string;
    package: { slug: string };
    candidate: { id: string; display_name: string; email: string };
  };
  report_items: Array<CandidateStoryRequestItem>;
};
